var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvanced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b5dbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.81,
    x2: 474.477,
    xlinkHref: "#lg1",
    y1: 55.025,
    y2: 356.692
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(-1 0 0 -1 627.785 510)",
    gradientUnits: "userSpaceOnUse",
    x1: 221.159,
    x2: 419.445,
    xlinkHref: "#lg1",
    y1: 215.173,
    y2: 413.459
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.054,
    x2: 39.821,
    y1: 478.946,
    y2: 135.713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07485e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3332,
    stopColor: "#063f52",
    stopOpacity: 0.333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#032632",
    stopOpacity: 0.936
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232e"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76e2f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b2e3"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.264,
    x2: 254.523,
    xlinkHref: "#lg2",
    y1: 269.394,
    y2: 484.653
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(-.707 -.707 .707 -.707 136.915 900.708)",
    gradientUnits: "userSpaceOnUse",
    x1: 303.894,
    x2: 445.383,
    xlinkHref: "#lg2",
    y1: 308.166,
    y2: 449.655
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m487.853 140.738h-8.88c-2.778-7.468-6.03-14.706-9.752-21.656l6.832-6.832c8.649-8.649 8.649-22.671 0-31.32l-46.983-46.983c-8.649-8.649-22.671-8.649-31.32 0l-8.811 8.811c-6.358-3-12.93-5.616-19.677-7.85v-12.761c0-12.232-9.916-22.147-22.147-22.147h-66.445c-12.231 0-22.147 9.915-22.147 22.147v12.761c-6.746 2.235-13.319 4.851-19.677 7.85l-8.811-8.811c-8.649-8.649-22.671-8.649-31.32 0l-46.983 46.983c-8.649 8.649-8.649 22.672 0 31.32l6.832 6.832c-3.722 6.95-6.974 14.188-9.752 21.656h-8.88c-12.231 0-22.147 9.915-22.147 22.147v66.444c0 12.231 9.915 22.147 22.147 22.147h4.906c2.586 8.861 5.839 17.439 9.72 25.663l-2.825 2.825c-8.649 8.649-8.649 22.671 0 31.32l46.983 46.983c8.649 8.649 22.671 8.649 31.32 0l.846-.845c8.792 4.709 18.038 8.678 27.643 11.858v.787c0 12.231 9.915 22.147 22.147 22.147h66.445c12.231 0 22.147-9.915 22.147-22.147v-.787c9.604-3.181 18.85-7.15 27.643-11.858l.846.845c8.649 8.649 22.671 8.649 31.32 0l46.983-46.983c8.649-8.649 8.649-22.671 0-31.32l-2.825-2.825c3.88-8.224 7.134-16.802 9.72-25.663h4.906c12.231 0 22.147-9.915 22.147-22.147v-66.444c-.004-12.231-9.919-22.147-22.151-22.147zm-173.96 132.149c-39.102 0-70.793-31.691-70.793-70.793s31.691-70.793 70.793-70.793 70.793 31.692 70.793 70.793-31.692 70.793-70.793 70.793z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.893 330.991c71.195 0 128.897-57.702 128.897-128.897s-57.702-128.898-128.897-128.898-128.897 57.702-128.897 128.897 57.701 128.898 128.897 128.898zm0-199.69c39.102 0 70.793 31.691 70.793 70.793s-31.691 70.793-70.793 70.793-70.793-31.692-70.793-70.793 31.691-70.793 70.793-70.793z",
    fill: "url(#SVGID_2_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m280.67 392.215h66.444c3.727 0 7.236-.925 10.317-2.551l-135.311-134.31c-6.172-6.172-15.177-6.172-21.348 0l-2.84 2.84-21.263-21.198c-2.849-4.145-7.619-4.865-13.028-4.865 0 0-45.723-.265-45.593.58 1.628 10.625 10.803 18.764 21.884 18.764h4.906c2.586 8.862 5.839 17.439 9.72 25.663l-2.825 2.825c-8.649 8.649-8.649 22.671 0 31.32l46.983 46.983c8.649 8.649 22.671 8.649 31.32 0l.846-.845c8.792 4.709 18.038 8.678 27.643 11.858v.787c-.001 12.233 9.914 22.149 22.145 22.149z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m264.067 330.556h-6.337c-1.982-5.329-4.303-10.494-6.959-15.453l4.875-4.875c6.172-6.171 6.172-16.177 0-22.349l-33.526-33.526c-6.171-6.172-16.177-6.172-22.349 0l-6.287 6.287c-4.537-2.14-9.227-4.007-14.041-5.602v-9.106c0-8.728-7.075-15.803-15.803-15.803h-47.412c-8.728 0-15.803 7.075-15.803 15.803v9.106c-4.814 1.594-9.504 3.461-14.041 5.602l-6.287-6.287c-6.172-6.172-16.177-6.172-22.349 0l-33.526 33.526c-6.172 6.172-6.172 16.178 0 22.349l4.875 4.875c-2.656 4.96-4.976 10.124-6.959 15.453h-6.337c-8.726 0-15.801 7.075-15.801 15.803v47.412c0 8.728 7.075 15.803 15.803 15.803h3.5c1.845 6.323 4.167 12.444 6.936 18.312l-2.016 2.016c-6.172 6.171-6.172 16.177 0 22.349l33.526 33.526c6.172 6.172 16.177 6.172 22.349 0l.603-.603c6.274 3.36 12.871 6.192 19.725 8.462v.562c0 8.728 7.075 15.803 15.803 15.803h47.412c8.728 0 15.803-7.075 15.803-15.803v-.562c6.853-2.27 13.451-5.102 19.725-8.462l.603.603c6.172 6.172 16.177 6.172 22.349 0l33.526-33.526c6.172-6.172 6.172-16.177 0-22.349l-2.016-2.016c2.769-5.869 5.09-11.989 6.936-18.312h3.501c8.728 0 15.803-7.075 15.803-15.803v-47.412c-.001-8.728-7.076-15.803-15.804-15.803zm-124.132 94.296c-27.901 0-50.515-22.614-50.515-50.515 0-27.902 22.614-50.515 50.515-50.515s50.515 22.614 50.515 50.515-22.614 50.515-50.515 50.515z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.972 309.299c-35.923-35.923-94.152-35.923-130.074 0s-35.923 94.152 0 130.074 94.152 35.923 130.074 0 35.923-94.151 0-130.074zm-100.757 100.757c-19.729-19.729-19.729-51.71 0-71.439s51.71-19.729 71.44 0c19.729 19.729 19.729 51.71 0 71.439-19.73 19.73-51.71 19.73-71.44 0z",
    fill: "url(#SVGID_5_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanced);
export default __webpack_public_path__ + "static/media/advanced.c17c7c4650c793eaf90c189f01451f0e.svg";
export { ForwardRef as ReactComponent };